import React from "react";

//COMPONENTS
import { HeaderLaptop, HeaderMobile } from "../components/Header";
import Cta from "../components/Cta";
import ServiceContent from "../components/ServiceContent";
//ASSETS
import BusinessAdvisoryImage from "../assets/business-advisory-header.svg";
import BAImg1 from "../assets/business-advisory-1.svg";
import BAImg2 from "../assets/business-advisory-2.svg";
import BAImg3 from "../assets/business-advisory-3.svg";

const content = [
  {
    text: (
      <p>
        Sometimes it helps to have someone to fall back on for some common-sense advice. 
        At Nectar Consulting we talk plain English; we say it as it is and we have experience 
        of running many businesses having invested our own equity.  So, when you are looking 
        to make changes be it for growth, stability, exit strategy, we have probably seen it, 
        done it, had the sleepless nights and also the battle scars to prove it.  
      </p>
    ),
    img: BAImg1,
  },
  {
    text: (
      <div>
        <p>
          Working with us is easy, with us it’s not always about the money, we look at the whole 
          picture and make suggestions throughout the whole process on the options available to 
          you and the upside and downside of each option.
          <br />
          We have experience of investing in:
        </p>
        <ul>
          <li>• Existing businesses </li>
          <li>• Helping owners exit businesses</li>
          <li>• Full sale</li>
          <li>• Management buyout</li>
          <li>• Valuations</li>
          <li>• Asset management and protection</li>
          <li>• Claiming Research and Development costs</li>
          <li>• Capital Allowance clams</li>
          <li>• Raising finance</li>
          <li>• Growth including organic and acquisitions</li>
        </ul>
      </div>
    ),
    img: BAImg2,
  },
  {
    text: (
      <p>
        Just as you are experts in your business, we are experts in ours.  We value trust and 
        understanding to help us work together to assist you to realise your business’s full potential. 
      </p>
    ),
    img: BAImg3,
  },
];

const BusinessAdvisory = () => {

  return (
    <div>
      <HeaderLaptop
        titlePart1="Business"
        titlePart2=" Advisory"
        pageSnippet="In business we understand how much you have to sacrifice, the sleepless nights, the stresses and we recognise it doesn’t always go the way you plan."
        headerIllustration={BusinessAdvisoryImage}
        alt="Business advisory conversation"
      />
      <HeaderMobile
        titlePart1="Business"
        titlePart2=" Advisory"
        pageSnippet="In business we understand how much you have to sacrifice, the sleepless nights, the stresses and we recognise it doesn’t always go the way you plan."
        headerIllustration={BusinessAdvisoryImage}
        alt="Business advisory conversation"
      />

      <div className="max-w-7xl mx-auto px-4 my-16 sm:px-6 lg:my-32">
        <h2 className="header2 text-center">
          Working with us is<span className="text-earth"> easy</span>
        </h2>
        <p className="text-center mt-8">In business we understand how much you have to sacrifice, the sleepless nights, the stresses and we recognise it doesn’t always go the way you plan.</p>
        {content.map((item, index) => (
          <ServiceContent
            key={index}
            isLast={index === content.length - 1}
            img={item.img}
            alt={item.alt}
            text={item.text}
            isLeftAlign={index % 2}
          />
        ))}
      </div>

      <Cta />
    </div>
  );
};

export default BusinessAdvisory;
